import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PatientDetails } from '@ffd/api-client';
import { AvatarsComponent, HighlightDirective } from '@libs/ui-lib';
import { PatientToPersonPipe, PhoneFormatPipe } from '../../pipes';
import { PatientItemActionsComponent } from '../patient-item-actions';
import { PatientStatusComponent } from '../patient-status';

@Component({
  selector: 'lib-patient-item',
  templateUrl: './patient-item.component.html',
  styleUrls: ['./patient-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    DatePipe,
    AvatarsComponent,
    PatientToPersonPipe,
    PatientStatusComponent,
    PatientItemActionsComponent,
    HighlightDirective,
    PhoneFormatPipe,
  ],
})
export class PatientItemComponent {
  @Input() public patient!: PatientDetails;
  @Input() public highlightedText: string | null | undefined = null;

  public get patientNameLabel(): string {
    return `${this.patient.firstName} <strong>${this.patient.lastName}</strong>`;
  }

  public toLocalDate(dateStr: string | undefined): Date | undefined {
    if (!dateStr) return undefined;
    const [y, m, d] = dateStr.split('-').map(Number);
    return new Date(y, m - 1, d); // local midnight
  }
}
